// extracted by mini-css-extract-plugin
module.exports = {"overlayContainer":"LoadingOverlay_overlayContainer__5ZgQ8","visible":"LoadingOverlay_visible__FhOyc"};